import { Box } from "@mui/material";

/**
 * Horizontal-scroll boundary for wide data tables (e.g. MUI DataGrid) on small
 * screens. Keeps the table contained so it scrolls sideways within its own box
 * instead of forcing the whole page to overflow horizontally on phones/tablets.
 *
 * NOTE: deliberately a single thin wrapper with no inner min-width box. Forcing a
 * min-width around an `autoHeight` DataGrid makes the grid's resize logic loop
 * ("Maximum update depth exceeded"), so we let the DataGrid manage its own
 * horizontal column scrolling and only guarantee the page itself can't overflow.
 */
export const TableScroll = ({ children, sx }) => (
  <Box sx={{ width: "100%", minWidth: 0, overflowX: "auto", ...sx }}>
    {children}
  </Box>
);
